import { ColumnInfo, ColumnInfoList, DisplaySetting } from 'components/shared/display_setting'
import { NestedSelectItem } from 'components/shared/input'
import { TableCell } from 'components/shared/widget'
import { MasterDataContext } from 'contexts/master_data_context'
import { Order } from 'entities/order'
import { ProbeStock } from 'entities/probe_stock'
import { useContext } from 'react'
import { ReactNode, useMemo } from 'react'
import { Badge } from 'react-bootstrap'
import { Form } from 'utils/hooks'
import { OrderViewModel } from 'view_models/order_view_model'

export const orderColumnInfoList = (form?: Form<Record<string, unknown>>): ColumnInfoList => {
    const masterData = useContext(MasterDataContext)

    const nestedSelectItems: NestedSelectItem = { Active: [], Inactive: [] }
    return {
        tableName: '',
        values: [
            { name: 'ID', th: true, align: 'center', width: 60, form: form, orderAttr: 'order_id', searchType: { name: 'id', type: 'multiple_text' } },
            { name: 'Status', th: true, align: 'center', width: 80 },
            { name: 'Date', th: true, width: 100, form: form, align: 'center', orderAttr: 'order_date', searchType: { name: 'date', type: 'date' } },
            { name: 'Sales Order', th: true, width: 100, form: form, align: 'center', orderAttr: 'sales_order', searchType: { name: 'salesOrder', type: 'multiple_text' } },
            {
                name: 'items',
                th: true,
                align: 'center',
                width: 100,
            },
            {
                name: 'stocks',
                th: true,
                align: 'center',
                width: 100,
            },
            {
                name: 'Type',
                th: true,
                width: 80,
                align: 'center',
                form: form,
                orderAttr: 'order_type',
                searchType: {
                    name: 'order_type',
                    type: 'select',
                    selectItems: [
                        { label: 96, value: 96 },
                        { label: 16, value: 16 },
                    ],
                },
            },
            { name: 'Note', th: true, width: 300, orderAttr: 'order_note', searchType: { name: 'sales_note', type: 'text' } },
        ],
    }
}

export type OrderTableDataProps = {
    order?: Order
    displaySetting: DisplaySetting
    onClickStocks?: (probeStocks?: ProbeStock[]) => void
}

export const OrderTableData = ({ order, displaySetting, onClickStocks }: OrderTableDataProps): JSX.Element => {
    if (!order) {
        return (
            <>
                {displaySetting.columnInfoList.values.map((_: ColumnInfo, index: number) => {
                    if (displaySetting.hiddenList.includes(index)) {
                        return <></>
                    } else {
                        return <TableCell key={index}></TableCell>
                    }
                })}
            </>
        )
    }

    const createCells = useMemo(() => {
        const vm = new OrderViewModel(order)
        return (
            <>
                <TableCell align="center">{order.id}</TableCell>
                <TableCell align="center">
                    {order.orderInspections && order.orderInspections.length > 0 && order.orderInspections.every((oi) => !!oi.inspectedAt) ? (
                        <Badge bg="success">検品済</Badge>
                    ) : order.orderInspections && order.orderInspections.length > 0 ? (
                        <Badge bg="primary">未検品</Badge>
                    ) : (
                        <Badge bg="secondary">未発注</Badge>
                    )}
                </TableCell>
                <TableCell align="center">{vm.date()}</TableCell>
                <TableCell>{order.salesOrder}</TableCell>
                <TableCell align="center" unit="製品">
                    {order.orderItems?.length}
                </TableCell>
                <TableCell align="center">
                    {order.probeStocks?.length && (
                        <a
                            onClick={() => {
                                if (onClickStocks) {
                                    onClickStocks(order.probeStocks)
                                }
                            }}
                            style={{ cursor: 'pointer', color: 'blue' }}
                        >
                            {order.probeStocks?.length}個 / <span style={{ fontSize: 10 }}>{order.totalCount}個</span>
                        </a>
                    )}
                </TableCell>
                <TableCell align="center">{order.type}</TableCell>
                <TableCell>{order.note}</TableCell>
            </>
        )
    }, [displaySetting.hiddenList])

    return createCells.props.children.filter((_: ReactNode, index: number) => !displaySetting.hiddenList?.includes(index)).map((cell: ReactNode) => cell)
}
